import { gql } from '@apollo/client';

export const createLocation = gql`
  mutation createLocation($input: CreateLocationInput) {
    createLocation(input: $input) {
      id
      state
      county
      township
      updater
      createdAt
      updatedAt
      deletedAt
      businessUnits {
        name
        id
      }
    }
  }
`;
